import * as React from "react";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
import { TextField } from "../textfield/textfield.mjs";
const PassField = (props) => {
  const labels = useLabels();
  return /* @__PURE__ */ React.createElement(
    AnalyticsTrigger,
    {
      trigger: {
        callback: "onToggle",
        id: "Field - Passfield - Show/Hide - ".concat(props.id),
        elementId: "".concat(props.id),
        elementType: "field",
        interactionType: "toggle"
      }
    },
    /* @__PURE__ */ React.createElement(PassFieldInner, { ...props, labels })
  );
};
class PassFieldInner extends React.Component {
  constructor(props) {
    var _a;
    super(props);
    this.onChange = (value) => {
      if (typeof this.props.value === "undefined") {
        this.setState({
          value
        });
      }
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    };
    this.onButtonClick = (event) => {
      event.preventDefault();
      this.setState((prevState) => {
        const nextIsVisible = !prevState.isVisible;
        if (this.props.onToggle) {
          this.props.onToggle(nextIsVisible);
        }
        return {
          isVisible: nextIsVisible
        };
      });
    };
    this.getButton = () => {
      const { labels, toggleButtonLabel } = this.props;
      return /* @__PURE__ */ React.createElement("button", { className: "passfield__button", onClick: this.onButtonClick, type: "button", "aria-pressed": this.state.isVisible ? "true" : "false" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: this.getButtonIcon(), className: "passfield__button-icon" }), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, toggleButtonLabel != null ? toggleButtonLabel : labels.get("passField.showPassword")));
    };
    this.state = {
      isVisible: false,
      value: (_a = props.defaultValue) != null ? _a : ""
    };
  }
  get value() {
    if (this.props.isReadOnly || this.props.isDisabled) {
      return typeof this.props.value !== "undefined" ? this.props.value : this.state.value;
    }
    return this.props.onChange && typeof this.props.value !== "undefined" ? this.props.value : this.state.value;
  }
  BEM() {
    const classArray = ["passfield"];
    if (this.state.isVisible) {
      classArray.push("is-visible");
    }
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  getInputType() {
    return this.state.isVisible ? "text" : "password";
  }
  getButtonIcon() {
    return this.state.isVisible ? "#password-hide" : "#password-show";
  }
  render() {
    const { labels, onToggle, toggleButtonLabel, ...rest } = this.props;
    return /* @__PURE__ */ React.createElement(
      TextField,
      {
        ...rest,
        className: this.BEM(),
        inputClass: "passfield__input",
        type: this.getInputType(),
        onChange: this.onChange,
        value: this.value,
        contentRenderer: this.getButton
      }
    );
  }
}
export {
  PassField
};
